import type { AuthenticationAccessRight } from "src/authentication/objects/AuthenticationToken";

export const StoreGroupAccessRight = {
  VIEW_STORE_GROUPS: ({ menuDisplayLevel }) =>
    menuDisplayLevel === 0 || menuDisplayLevel === 1,
  VIEW_STORE_GROUP_DROPDOWN: ({ menuDisplayLevel }) =>
    menuDisplayLevel === 0 ||
    menuDisplayLevel === 1 ||
    menuDisplayLevel === 2 ||
    menuDisplayLevel === 4,
} satisfies Record<string, AuthenticationAccessRight>;
